import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmProvider";
import CanonicalUrl from "@/components/CanonicalUrl";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import KBPage from "@/pages/KBPage";
import IdentityPage from "@/pages/IdentityPage";
import StorybankPage from "@/pages/StorybankPage";
import SwipesPage from "@/pages/SwipesPage";
import DraftingStudio from "@/pages/DraftingStudio";
import PlannerPage from "@/pages/PlannerPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import TrashPage from "@/pages/TrashPage";
import CommentsPage from "@/pages/CommentsPage";
import PovsPage from "@/pages/PovsPage";
import AdminPage from "@/pages/AdminPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordResetPages";

function Loader() {
  return <div className="min-h-screen flex items-center justify-center text-sm" style={{color:'var(--ink-3)'}}>Loading…</div>;
}

function Protected({ children, proOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader/>;
  if (!user) return <Navigate to="/login" replace />;
  // Trial users can only access trial-allowed routes
  if (proOnly && user.plan === "trial") return <Navigate to="/app/draft" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppIndex() {
  const { user } = useAuth();
  if (user === null) return <Loader/>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.plan === "trial") return <Navigate to="/app/draft" replace />;
  return <AppShell><Dashboard /></AppShell>;
}

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <CanonicalUrl />
        <Toaster position="top-right" richColors duration={3500} closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/app" element={<AppIndex />} />
          <Route path="/app/kb" element={<Protected><KBPage /></Protected>} />
          <Route path="/app/identity" element={<Protected><IdentityPage /></Protected>} />
          <Route path="/app/storybank" element={<Protected><StorybankPage /></Protected>} />
          <Route path="/app/swipes" element={<Protected proOnly><SwipesPage /></Protected>} />
          <Route path="/app/draft" element={<Protected><DraftingStudio /></Protected>} />
          <Route path="/app/planner" element={<Protected proOnly><PlannerPage /></Protected>} />
          <Route path="/app/analytics" element={<Protected proOnly><AnalyticsPage /></Protected>} />
          <Route path="/app/comments" element={<Protected><CommentsPage /></Protected>} />
          <Route path="/app/pov" element={<Protected><PovsPage /></Protected>} />
          <Route path="/app/admin" element={<Protected><AdminPage /></Protected>} />
          <Route path="/app/trash" element={<Protected><TrashPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
